import { CY_TRAINING_DETAILS } from '../../../../lib/constants/cypress';
import { useViewContext } from '../../../../lib/context/ViewContext';
import { DetailsLinkDestination } from '../../../../lib/hooks/useGetDetailsLink';
import { AemLearningDetailsBaseProps } from '../../../../lib/types/aemDataModels';
import { Api } from '../../../../lib/types/apiSpec';
import { isNil } from '../../../../lib/utils/isNil';
import BaseLearningDetails from '../../base/BaseLearningDetails/BaseLearningDetails';
import LearningLink, { getCustomLinkElement } from '../../base/LearningLink/LearningLink';
import styles from '../../base/BaseLearningDetails/BaseLearningDetails.module.scss';
import { Role, useRole } from '../../../../lib/context/SessionContext';

export type EventDetailsProps = AemLearningDetailsBaseProps<Api.EventDetails> & {
  eventNotAvailableMessage?: string;
};

const EventDetails = ({ eventNotAvailableMessage, ...props }: EventDetailsProps) => {
  const { page, isLoading } = useViewContext();
  const { event, error } = page;
  const role = useRole();

  if (isNil(event) && !isLoading && !error) {
    return null;
  }

  return (
    <BaseLearningDetails<Api.EventDetails>
      {...props}
      data={event}
      isLoading={!!isLoading}
      error={error}
      button={
        <LearningLink
          className={styles.downloadAssetAnchor}
          id={event?.accessDetails?.courseId ?? ''}
          originalId={event?.accessDetails?.litmosCourseId}
          eventId={event?.id}
          eventOriginalId={event?.accessDetails?.litmosEventId}
          type={Api.EventType.Event}
          name={event?.name ?? ''}
          ContentElement={getCustomLinkElement()}
          checkIfAvailable
          data-cy={CY_TRAINING_DETAILS.BUTTON}
          eventRegistrationUrl={event?.accessDetails?.registrationUrl}
          to={role === Role.GUEST ? DetailsLinkDestination.REGISTER : DetailsLinkDestination.LITMOS}
          notAvailableMessage={eventNotAvailableMessage}
        />
      }
    />
  );
};

export default EventDetails;
